export default __webpack_public_path__ + "static/media/AddUser.eebe94fc.svg";